import { OnInit, EventEmitter } from '@angular/core';
import { Session } from "../../service/util/Session";
import { FormField } from "../../model/Form";
import { Select2Component } from 'ng2-select2';
import { GroupsService } from "../../service/admin/GroupsService";
import { ErrorHandlerService } from "../../service/ErrorHandlerService";
import { CurrentUserService } from 'service/currentUser/CurrentUserService';
import { logger } from "../../service/util/Logger";
var UserGroupSelectComponent = /** @class */ (function () {
    function UserGroupSelectComponent(groupsService, session, errorHandler, currentUserService) {
        this.groupsService = groupsService;
        this.session = session;
        this.errorHandler = errorHandler;
        this.currentUserService = currentUserService;
        this._value = '';
        // Implies a read only state
        this.disabled = false;
        /**
         * Restrict available user groups to the user groups available to the current user
         */
        this.restrictGroups = false;
        this.multiple = false;
        this.defaultValue = '';
        this.userGroupSelectData = [];
        this.change = new EventEmitter();
    }
    Object.defineProperty(UserGroupSelectComponent.prototype, "value", {
        get: function () {
            return this._value;
        },
        /**
         * By preventing assigning non-unique values during the set
         * we can prevent a loop of observable subscribers
         */
        set: function (newValue) {
            this._value = newValue;
            if (!this.field && !this.multiple) {
                this.defaultValue = this._value;
            }
        },
        enumerable: true,
        configurable: true
    });
    UserGroupSelectComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.userGroupSelectOptions = { allowClear: !this.multiple, placeholder: this.placeholder || "Select Department", multiple: this.multiple };
        this.session.lockInputRx(this.groupsService.getGroups())
            .subscribe(function (items) {
            var newSelectOptions = [{ id: "", text: "" }];
            // remove groups that is not assigned to current user with role manager.
            if (_this.restrictGroups) {
                var userGroups_1 = _this.currentUserService.currentUserData.value.groups;
                if (userGroups_1 && userGroups_1.length > 0) {
                    items = items.filter(function (item) {
                        return !!userGroups_1.find(function (userGroup) { return userGroup.id === item.id; });
                    });
                }
            }
            items.forEach(function (group) { return newSelectOptions.push({ id: String(group.id), text: group.groupName }); });
            _this.userGroupSelectData = newSelectOptions;
            //Force the change detection to cycle again to prevent race
            if (_this.field) {
                var strVal = String(_this.field.value);
                if (String(_this.field.value) !== _this.defaultValue) {
                    var fieldValueArr_1 = _this.multiple && strVal ? strVal.split(",") : undefined;
                    if (!_this.multiple) {
                        _this.defaultValue = strVal;
                    }
                    var options = _this.userGroupSelectData.filter(function (o) { return (_this.multiple ? (fieldValueArr_1 ? fieldValueArr_1.find(function (selectedValue) { return selectedValue === String(o.id); }) : false) : o.id === _this._value); });
                    if (options && options.length) {
                        options.map(function (opt) { return opt.selected = true; });
                    }
                }
            }
            else {
                //If the default value was manually set we need to re-trigger the process
                if (_this._value !== '') {
                    var valueArr_1 = _this.multiple && _this._value && _this._value.length ? _this._value.split(",") : undefined;
                    if (!_this.multiple) {
                        _this.defaultValue = _this.value;
                    }
                    var options = _this.userGroupSelectData.filter(function (o) { return (_this.multiple ? (valueArr_1 ? valueArr_1.find(function (selectedValue) { return selectedValue === String(o.id); }) : false) : o.id === _this._value); });
                    if (options && options.length) {
                        options.map(function (opt) { return opt.selected = true; });
                    }
                }
            }
        }, function (err) { return _this.errorHandler.handleHttpError(err); });
    };
    UserGroupSelectComponent.prototype.valueChanged = function (selectedOpts) {
        // console.log("valueChanged");
        // console.log(selectedOpts);
        if (selectedOpts.length === 0 || (selectedOpts.length === 1 && selectedOpts[0].id.length === 0 && selectedOpts[0].text.length === 0)) {
            if (this.field)
                this.field.value = null;
        }
        if (selectedOpts.length > 1 && !this.multiple)
            throw ("Selected options unexpectedly contained multiple results");
        if (selectedOpts.length === 1 && !this.multiple) {
            if (this.field) {
                this.field.value = selectedOpts[0].id;
            }
            else {
                if (this._value !== selectedOpts[0].id) { // if the value has been changed - emit event
                    this._value = selectedOpts[0].id;
                    this.change.emit(selectedOpts);
                    return;
                }
            }
        }
        if (this.multiple) {
            var actualSelected = selectedOpts.filter(function (opt) { return opt.id && opt.id.length; });
            var newValue = actualSelected.map(function (opt) { return opt.id; }).join(",");
            if (this.field) {
                console.log("Setting Field Value ", newValue);
                this.field.value = newValue;
            }
            else {
                logger.silly("Checking internalValue change Value[(" + typeof newValue + ") " + newValue + "] !== _value[(" + typeof this._value + ") " + this._value + "]");
                if (this._value !== newValue) { // if the value has been changed - emit event
                    logger.silly("userGroupSelectComponent: Updating Internal Value");
                    this._value = newValue;
                    this.change.emit(actualSelected);
                }
            }
        }
    };
    return UserGroupSelectComponent;
}());
export { UserGroupSelectComponent };
